// extracted by mini-css-extract-plugin
module.exports = {"root":"IconReceipt_root__3IWor"};